import { sectionType } from '../type';
import {
  bannerSection,
  bannerHsiaSection,
  cardSonaSection,
  cardEcoSection,
  cardCigarSection,
  cardKynorelleSection,
  cardHsiaGridSection,
  cardReviewHsiaGridSection,
  cardHsiaCategorySection,
  cardHsiaTagsSection,
  cardHsiaTextWithIconSection,
  cardFaqKynorelleSection,
  sliderReviewKynorelleSection,
  cardVideoSection,
  cardVideoSliderSection,
  productsSliderSection,
  bannerKynorelleSection,
  gridItemKynorelleSection,
  gridItemKynorelle02Section,
  gridItemKynorelle03Section,
  gridItemKynorelle04Section,
  gridItemKynorelle05Section,
  markqueueKynorelleSection,
  marqueeKyroroSection,
  marqueeBoxerItemSection,
  textWithIconSection,
  sliderItemFyroroTemplateSection,
  sliderItemBoxerSection,
  productWithVariantSection,
  freestyleSection,
  cardGridBoxerSection,
  cardWithTabsBoxerSection,
  cardMultiBoxerSection,
  reviewsBoxerSection,
  sliderBoxerProductSection,
  imageWithTextConvenFeet01Section,
  imageWithTextConvenFeet02Section,
  imageWithTextConvenFeet03Section,
  iconGridWithHeroTextConvenFeetSection,
  calyrafitBannerSection,
  calyrafitMarquee01Section,
  calyrafitMarqueeSection,
  calyrafitGirdImageSection,
  calyrafitBestSallerSection,
  calyrafitSideBySideSection,
  calyrafitSlideSection,
  calyrafitCollectionsSection,
  calyrafitTextWithIconSection,
  calyrafitReviewSection,
  calyrafitFooterSection,
  ceflorecoBanner1Section,
  ceflorecoProductWorldSection,
  ceflorecoBanner2Section,
  ceflorecoTextGradientSection,
  ceflorecoSideBySideSection,
  ceflorecoMobileAppSection,
  ceflorecoBenefisSection,
  ceflorecoLetsTalkSection,
  ceflorecoFooterSection,
} from '../section-templates';
//import images
import bannerSliderImg from '@/assets/images/homepage-theme/banner-slider.webp';
import cardSonaImg from '@/assets/images/homepage-theme/card-sona.webp';
import ecoImg from '@/assets/images/homepage-theme/eco.png';
import cigarImg from '@/assets/images/homepage-theme/card-cigar.webp';
import gridItemKynorelleImg from '@/assets/images/homepage-theme/grid-item-kynorelle.webp';
import videoImg from '@/assets/images/homepage-theme/card-video.gif';
import videoSliderImg from '@/assets/images/homepage-theme/card-slider-video.webp';
import productsSliderImg from '@/assets/images/homepage-theme/products-slider.webp';
import bannerKynorelleImg from '@/assets/images/homepage-theme/banner-kynorelle.webp';
import textWithIconImg from '@/assets/images/homepage-theme/text-with-icon.webp';
import gridItemKynorelle02Img from '@/assets/images/homepage-theme/grid-item-kynorelle-02.webp';
import gridItemKynorelle03Img from '@/assets/images/homepage-theme/grid-item-kynorelle-03.webp';
import gridItemKynorelle04Img from '@/assets/images/homepage-theme/grid-item-kynorelle-04.webp';
import gridItemKynorelle05Img from '@/assets/images/homepage-theme/grid-item-kynorelle-05.webp';
import cardKynorelleImg from '@/assets/images/homepage-theme/card-kynorelle.webp';
import cardFaqKynorelleImg from '@/assets/images/homepage-theme/card-faq-kynorelle.webp';
import sliderReviewKynorelleImg from '@/assets/images/homepage-theme/slider-review-kynorelly.webp';
import markqueueKynorelleImg from '@/assets/images/homepage-theme/markqueue-kynorelle.webp';
import marqueeKyroroImg from '@/assets/images/homepage-theme/marquee-kyroro.webp';
import sliderItemFyroroImg from '@/assets/images/homepage-theme/slider-products-fyroro.webp';
import sliderItemBoxerImg from '@/assets/images/homepage-theme/slider-item-boxer.webp';
import productWithVariantImg from '@/assets/images/homepage-theme/product-with-variant.webp';
import bannerHsiaImg from '@/assets/images/homepage-theme/banner-hsia.webp';
import cardHsiaTagsImg from '@/assets/images/homepage-theme/tags-hsia.webp';
import cardHsiaCategoryImg from '@/assets/images/homepage-theme/hsia-category.webp';
import cardHsiaGridImg from '@/assets/images/homepage-theme/hsia-grid.webp';
import cardReviewHsiaGridImg from '@/assets/images/homepage-theme/review-hsia.webp';
import cardHsiaTextWithIconImg from '@/assets/images/homepage-theme/text-with-icon-hsia.webp';
import freestyleImg from '@/assets/images/homepage-theme/freestyle.webp';
import cardGridBoxerImg from '@/assets/images/homepage-theme/grid-boxer.webp';
import cardWithTabsBoxerImg from '@/assets/images/homepage-theme/card-with-tab-boxer.webp';
import cardMultiBoxerImg from '@/assets/images/homepage-theme/card-boxer-multi.webp';
import reviewsBoxerImg from '@/assets/images/homepage-theme/review-boxer.webp';
import sliderBoxerProductImg from '@/assets/images/homepage-theme/slider-boxer-product.webp';
import marqueeBoxerItemImg from '@/assets/images/homepage-theme/marquee-boxer.webp';
import imageWithTextConvenFeet01Img from '@/assets/images/homepage-theme/thumnail-iwt-conven-feet.webp';
import iconGridWithHeroTextConvenFeetImg from '@/assets/images/homepage-theme/icon-grid-with-hero-text.webp';
import imageWithTextConvenFeet02Img from '@/assets/images/homepage-theme/thumbnail-iwt-02.webp';
import imageWithTextConvenFeet03Img from '@/assets/images/homepage-theme/thumbnail-iwt-03.webp';
import calyrafitBannerImg from '@/assets/images/homepage-theme/thumbnail-banner-calyrafit.webp';
import calyrafitMarquee01Img from '@/assets/images/homepage-theme/thumbnail-marquee-calyrafit.webp';
import calyrafitMarqueeImg from '@/assets/images/homepage-theme/thumbnail-marquee-img-calyrafit.webp';
import calyrafitGirdImageImg from '@/assets/images/homepage-theme/thumbnail-grid-calyrafit.webp';
import calyrafitBestSallerImg from '@/assets/images/homepage-theme/thumbnail-best-saller-calyrafit.webp';
import calyrafitSideBySideImg from '@/assets/images/homepage-theme/thumbnail-side-by-side-calyrafit.webp';
import calyrafitSlideImg from '@/assets/images/homepage-theme/thumbnail-slide-calyrafit.webp';
import calyrafitCollectionsImg from '@/assets/images/homepage-theme/thumbnail-collections-calyrafit.webp';
import calyrafitTextWithIconImg from '@/assets/images/homepage-theme/thumbnail-text-with-icon-calyrafit.webp';
import calyrafitReviewImg from '@/assets/images/homepage-theme/thumbnail-review-calyrafit.webp';
import ceflorecoBanner1Img from '@/assets/images/homepage-theme/cefloreco-banner-1-thumbnail.webp';
import ceflorecoProductWorldImg from '@/assets/images/homepage-theme/thumbnail-product-world.webp';
import ceflorecoBanner2Img from '@/assets/images/homepage-theme/thumbnail-banner-2.webp';
import ceflorecoTextGradientImg from '@/assets/images/homepage-theme/thumbnail-textgradient.webp';
import ceflorecoSideBySideImg from '@/assets/images/homepage-theme/thumbnail-side-by-side.webp';
import ceflorecoMobileAppImg from '@/assets/images/homepage-theme/thumbnail-mobile-apps.webp';
import ceflorecoBenefisImg from '@/assets/images/homepage-theme/ceflore-thumbnail-benefits.webp';
import ceflorecoLetsTalkImg from '@/assets/images/homepage-theme/thumbnail-letstalk.png';
import ceflorecoFooterImg from '@/assets/images/homepage-theme/footer-thumbnail-ceflore.webp';
import calyrafitFooterImg from '@/assets/images/homepage-theme/thumbnail-footer-calyrafit.png';

export const TplType = {
  Banner: 'banner',
  Other: 'other',
  CardBasic: 'card-basic',
  CardVideo: 'card-video',
  Products: 'products',
  Carousel: 'carousel',
  TextWithIcon: 'text-with-icon',
  GridItems: 'grid-items',
  Markqueues: 'markqueues',
  Freestyle: 'freestyle',
  Footer: 'footer',
  // CarouselItems: 'carousel-items',
};
export default {
  data() {
    return {
      activeItem: 'All templates',
      activeGroup: null,
      categoryTpl: [
        {
          action: 'mdi-file-multiple',
          active: true,
          title: 'All templates',
        },
        {
          action: 'mdi-image-area',
          items: [{ title: 'Banner slider', tplType: TplType.Banner }],
          title: 'Banner',
        },
        {
          action: 'mdi-card',
          items: [
            { title: 'Card basic', tplType: TplType.CardBasic },
            { title: 'Card video', tplType: TplType.CardVideo },
          ],
          title: 'Card',
        },
        {
          action: 'mdi-view-grid',
          items: [{ title: 'Slider Products', tplType: TplType.Products }],
          title: 'Products',
        },
        {
          action: 'mdi-view-grid',
          items: [{ title: 'Grid Kynorelle', tplType: TplType.GridItems }],
          title: 'Grid Items',
        },
        {
          action: 'mdi-star-four-points-outline',
          items: [{ title: 'basic', tplType: TplType.TextWithIcon }],
          title: 'Text with icon',
        },
        {
          action: 'mdi-view-carousel',
          items: [
            { title: 'Carousel Basic', tplType: TplType.Carousel },
            { title: 'Markqueue', tplType: TplType.Markqueues },
          ],
          title: 'Carousel',
        },
        {
          action: 'mdi-view-grid',
          items: [{ title: 'Freestyle', tplType: TplType.Freestyle }],
          title: 'Freestyle',
        },
        {
          action: 'mdi-page-layout-footer',
          items: [{ title: 'Basic Footer', tplType: TplType.Footer }],
          title: 'Footer',
        },
      ],
      sectionTemplates: [
        //Banners
        {
          id: sectionType.sectionBanner,
          title: 'Banner Slider Section',
          tplType: TplType.Banner,
          type: sectionType.sectionBanner,
          html: `<section data-section="${sectionType.sectionBanner}-123hfg" data-type="${sectionType.sectionBanner}" data-title="Banner Slider Section" data-attribute="section-title">
              ${bannerSection}
          </section>`,
          image: bannerSliderImg,
        },
        {
          id: sectionType.sectionBannerHsia,
          title: 'Banner Hsia Section',
          tplType: TplType.Banner,
          type: sectionType.sectionBannerHsia,
          html: `<section data-section="${sectionType.sectionBannerHsia}-123hfg" data-type="${sectionType.sectionBannerHsia}" data-title="Banner Hsia Section" data-attribute="section-title">
              ${bannerHsiaSection}
          </section>`,
          image: bannerHsiaImg,
        },
        //Cards
        {
          id: sectionType.sectionCardSona,
          title: 'Card Sona Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardSona,
          html: `<section data-section="${sectionType.sectionCardSona}-123hfg" data-type="${sectionType.sectionCardSona}" data-title="Card Sona Section" data-attribute="section-title">
              ${cardSonaSection}
          </section>`,
          image: cardSonaImg,
        },
        {
          id: sectionType.sectionCardCigar,
          title: 'Card Eco Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardCigar,
          html: `<section data-section="${sectionType.sectionCardCigar}-6r48va" data-type="${sectionType.sectionCardCigar}" data-title="Card Eco Section" data-attribute="section-title">
                ${cardEcoSection}
            </section>`,
          image: ecoImg,
        },
        {
          id: sectionType.sectionCardCigar,
          title: 'Card Cigar Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardCigar,
          html: `<section data-section="${sectionType.sectionCardCigar}-6r48va" data-type="${sectionType.sectionCardCigar}" data-title="Card Cigar Section" data-attribute="section-title">
                ${cardCigarSection}
            </section>`,
          image: cigarImg,
        },
        {
          id: sectionType.sectionCardKynorelle,
          title: 'Card Kynorelle Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardKynorelle,
          html: `<section data-section="${sectionType.sectionCardKynorelle}-6r48va" data-type="${sectionType.sectionCardKynorelle}" data-title="Card Kynorelle Section" data-attribute="section-title">
                ${cardKynorelleSection}
            </section>`,
          image: cardKynorelleImg,
        },
        {
          id: sectionType.sectionCardHsiaGrid,
          title: 'Card Hsia Grid Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardHsiaGrid,
          html: `<section data-section="${sectionType.sectionCardHsiaGrid}-6r48va" data-type="${sectionType.sectionCardHsiaGrid}" data-title="Card Hsia Grid Section" data-attribute="section-title">
                ${cardHsiaGridSection}
            </section>`,
          image: cardHsiaGridImg,
        },
        {
          id: sectionType.sectionCardReviewHsiaGrid,
          title: 'Card Review Hsia Grid Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardReviewHsiaGrid,
          html: `<section data-section="${sectionType.sectionCardReviewHsiaGrid}-6r48va" data-type="${sectionType.sectionCardReviewHsiaGrid}" data-title="Card Review Hsia Grid Section" data-attribute="section-title">
                ${cardReviewHsiaGridSection}
            </section>`,
          image: cardReviewHsiaGridImg,
        },
        {
          id: sectionType.sectionCardHsiaCategory,
          title: 'Card Hsia Category Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardHsiaCategory,
          html: `<section data-section="${sectionType.sectionCardHsiaCategory}-6r48va" data-type="${sectionType.sectionCardHsiaCategory}" data-title="Card Hsia Category Section" data-attribute="section-title">
                ${cardHsiaCategorySection}
            </section>`,
          image: cardHsiaCategoryImg,
        },
        {
          id: sectionType.sectionCardHsiaTags,
          title: 'Card Hsia Tags Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardHsiaTags,
          html: `<section data-section="${sectionType.sectionCardHsiaTags}-6r48va" data-type="${sectionType.sectionCardHsiaTags}" data-title="Card Hsia Tags Section" data-attribute="section-title">
                ${cardHsiaTagsSection}
            </section>`,
          image: cardHsiaTagsImg,
        },
        {
          id: sectionType.sectionCardHsiaTextWithIcon,
          title: 'Card Hsia Text With Icon Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardHsiaTextWithIcon,
          html: `<section data-section="${sectionType.sectionCardHsiaTextWithIcon}-6r48va" data-type="${sectionType.sectionCardHsiaTextWithIcon}" data-title="Card Hsia Text With Icon Section" data-attribute="section-title">
                ${cardHsiaTextWithIconSection}
            </section>`,
          image: cardHsiaTextWithIconImg,
        },
        {
          id: sectionType.sectionCardFaqKynorelle,
          title: 'Card FAQ Kynorelle Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardFaqKynorelle,
          html: `<section data-section="${sectionType.sectionCardFaqKynorelle}-6r48va" data-type="${sectionType.sectionCardFaqKynorelle}" data-title="Card FAQ Kynorelle Section" data-attribute="section-title">
                ${cardFaqKynorelleSection}
            </section>`,
          image: cardFaqKynorelleImg,
        },
        {
          id: sectionType.sectionSliderReviewKynorelle,
          title: 'Slider Review Kynorelle Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionSliderReviewKynorelle,
          html: `<section data-section="${sectionType.sectionSliderReviewKynorelle}-6r48va" data-type="${sectionType.sectionSliderReviewKynorelle}" data-title="Slider Review Kynorelle Section" data-attribute="section-title">
                ${sliderReviewKynorelleSection}
            </section>`,
          image: sliderReviewKynorelleImg,
        },
        {
          id: sectionType.sectionCardVideo,
          title: 'Card Video Section',
          tplType: TplType.CardVideo,
          type: sectionType.sectionCardVideo,
          html: `<section data-section="${sectionType.sectionCardVideo}-dwd2" data-type="${sectionType.sectionCardVideo}" data-title="Card Video Section" data-attribute="section-title">
                ${cardVideoSection}
            </section>`,
          image: videoImg,
        },
        {
          id: sectionType.sectionCardVideoSlider,
          title: 'Card Video Slider Section',
          tplType: TplType.CardVideo,
          type: sectionType.sectionCardVideoSlider,
          html: `<section data-section="${sectionType.sectionCardVideoSlider}-dwd2" data-type="${sectionType.sectionCardVideoSlider}" data-title="Card Video Slider Section" data-attribute="section-title">
                ${cardVideoSliderSection}
            </section>`,
          image: videoSliderImg,
        },
        {
          id: sectionType.sectionProducts,
          title: 'Products Slider Section',
          tplType: TplType.Products,
          type: sectionType.sectionProducts,
          html: `<section data-section="${sectionType.sectionProducts}-dwd2" data-type="${sectionType.sectionCardVideoSlider}" data-title="Products Slider Section" data-attribute="section-title">
                ${productsSliderSection}
            </section>`,
          image: productsSliderImg,
        },
        {
          id: sectionType.sectionBannerKynorelle,
          title: 'Banner Kynorelle Section',
          tplType: TplType.Banner,
          type: sectionType.sectionBannerKynorelle,
          html: `<section data-section="${sectionType.sectionBannerKynorelle}-dwd2" data-type="${sectionType.sectionBannerKynorelle}" data-title="Banner Kynorelle Section" data-attribute="section-title">
                ${bannerKynorelleSection}
            </section>`,
          image: bannerKynorelleImg,
        },
        {
          id: sectionType.sectionGridItemKynorelle,
          title: 'Grid Item Kynorelle Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionGridItemKynorelle,
          html: `<section data-section="${sectionType.sectionGridItemKynorelle}-dwd2" data-type="${sectionType.sectionGridItemKynorelle}" data-title="Grid Item Kynorelle Section" data-attribute="section-title">
                ${gridItemKynorelleSection}
            </section>`,
          image: gridItemKynorelleImg,
        },
        {
          id: sectionType.sectionGridItemKynorelle02,
          title: 'Grid Item Kynorelle 02 Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionGridItemKynorelle02,
          html: `<section data-section="${sectionType.sectionGridItemKynorelle02}-dwd2" data-type="${sectionType.sectionGridItemKynorelle02}" data-title="Grid Item Kynorelle 02 Section" data-attribute="section-title">
                ${gridItemKynorelle02Section}
            </section>`,
          image: gridItemKynorelle02Img,
        },
        {
          id: sectionType.sectionMarkqueueKynorelle,
          title: 'Markqueue Kynorelle Section',
          tplType: TplType.Markqueues,
          type: sectionType.sectionMarkqueueKynorelle,
          html: `<section data-section="${sectionType.sectionMarkqueueKynorelle}-dwd2" data-type="${sectionType.sectionMarkqueueKynorelle}" data-title="Markqueue Kynorelle Section" data-attribute="section-title">
                ${markqueueKynorelleSection}
            </section>`,
          image: markqueueKynorelleImg,
        },
        {
          id: sectionType.sectionMarqueeKyroro,
          title: 'Marquee Kyroro Section',
          tplType: TplType.Markqueues,
          type: sectionType.sectionMarqueeKyroro,
          html: `<section data-section="${sectionType.sectionMarqueeKyroro}-dwd2" data-type="${sectionType.sectionMarqueeKyroro}" data-title="Marquee Kyroro Section" data-attribute="section-title">
                ${marqueeKyroroSection}
            </section>`,
          image: marqueeKyroroImg,
        },
        {
          id: sectionType.sectionMarqueeBoxerItem,
          title: 'Marquee Boxer Item Section',
          tplType: TplType.Markqueues,
          type: sectionType.sectionMarqueeBoxerItem,
          html: `<section data-section="${sectionType.sectionMarqueeBoxerItem}-dwd2" data-type="${sectionType.sectionMarqueeBoxerItem}" data-title="Marquee Boxer Item Section" data-attribute="section-title">
                ${marqueeBoxerItemSection}
            </section>`,
          image: marqueeBoxerItemImg,
        },
        {
          id: sectionType.sectionGridItemKynorelle03,
          title: 'Grid Item Kynorelle 03 Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionGridItemKynorelle03,
          html: `<section data-section="${sectionType.sectionGridItemKynorelle03}-dwd2" data-type="${sectionType.sectionGridItemKynorelle03}" data-title="Grid Item Kynorelle 03 Section" data-attribute="section-title">
                ${gridItemKynorelle03Section}
            </section>`,
          image: gridItemKynorelle03Img,
        },
        {
          id: sectionType.sectionGridItemKynorelle04,
          title: 'Grid Item Kynorelle 04 Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionGridItemKynorelle04,
          html: `<section data-section="${sectionType.sectionGridItemKynorelle04}-dwd2" data-type="${sectionType.sectionGridItemKynorelle04}" data-title="Grid Item Kynorelle 04 Section" data-attribute="section-title">
                ${gridItemKynorelle04Section}
            </section>`,
          image: gridItemKynorelle04Img,
        },
        {
          id: sectionType.sectionGridItemKynorelle05,
          title: 'Grid Item Kynorelle 05 Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionGridItemKynorelle05,
          html: `<section data-section="${sectionType.sectionGridItemKynorelle05}-dwd2" data-type="${sectionType.sectionGridItemKynorelle05}" data-title="Grid Item Kynorelle 05 Section" data-attribute="section-title">
                ${gridItemKynorelle05Section}
            </section>`,
          image: gridItemKynorelle05Img,
        },
        {
          id: sectionType.sectionTextWithIcon,
          title: 'Text With Icon Section',
          tplType: TplType.TextWithIcon,
          type: sectionType.sectionTextWithIcon,
          html: `<section data-section="${sectionType.sectionTextWithIcon}-dwd2" data-type="${sectionType.sectionTextWithIcon}" data-title="Text With Icon Section" data-attribute="section-title">
                ${textWithIconSection}
            </section>`,
          image: textWithIconImg,
        },
        {
          id: sectionType.sectionSliderItemFyroro,
          title: 'Slider Item Fyroro Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionSliderItemFyroro,
          html: `<section data-section="${sectionType.sectionSliderItemFyroro}-dwd2" data-type="${sectionType.sectionSliderItemFyroro}" data-title="Slider Item Fyroro Section" data-attribute="section-title">
                ${sliderItemFyroroTemplateSection}
            </section>`,
          image: sliderItemFyroroImg,
        },
        {
          id: sectionType.sectionSliderItemBoxer,
          title: 'Slider Item Boxer Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionSliderItemBoxer,
          html: `<section data-section="${sectionType.sectionSliderItemBoxer}-dwd2" data-type="${sectionType.sectionSliderItemBoxer}" data-title="Slider Item Boxer Section" data-attribute="section-title">
                ${sliderItemBoxerSection}
            </section>`,
          image: sliderItemBoxerImg,
        },
        {
          id: sectionType.sectionProductWithVariant,
          title: 'Product With Variant Hsia Section',
          tplType: TplType.Products,
          type: sectionType.sectionProductWithVariant,
          html: `<section data-section="${sectionType.sectionProductWithVariant}-dwd2" data-type="${sectionType.sectionProductWithVariant}" data-title="Product With Variant Section" data-attribute="section-title">
                ${productWithVariantSection}
            </section>`,
          image: productWithVariantImg,
        },
        {
          id: sectionType.sectionFreestyle,
          title: 'Freestyle Section',
          tplType: TplType.Freestyle,
          type: sectionType.sectionFreestyle,
          html: `<section class="ck-content" data-section="${sectionType.sectionFreestyle}-dwd2" data-type="${sectionType.sectionFreestyle}" data-title="Freestyle Section" data-attribute="section-title">
                ${freestyleSection}
            </section>`,
          image: freestyleImg,
        },
        {
          id: sectionType.sectionCardGridBoxer,
          title: 'Card Grid Boxer Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionCardGridBoxer,
          html: `<section data-section="${sectionType.sectionCardGridBoxer}-dwd2" data-type="${sectionType.sectionCardGridBoxer}" data-title="Card Grid Boxer Section" data-attribute="section-title">
                ${cardGridBoxerSection}
            </section>`,
          image: cardGridBoxerImg,
        },
        {
          id: sectionType.sectionCardWithTabsBoxer,
          title: 'Card With Tabs Boxer Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardWithTabsBoxer,
          html: `<section data-section="${sectionType.sectionCardWithTabsBoxer}-dwd2" data-type="${sectionType.sectionCardWithTabsBoxer}" data-title="Card With Tabs Boxer Section" data-attribute="section-title">
                ${cardWithTabsBoxerSection}
            </section>`,
          image: cardWithTabsBoxerImg,
        },
        {
          id: sectionType.sectionCardMultiBoxer,
          title: 'Card Multi Boxer Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardMultiBoxer,
          html: `<section data-section="${sectionType.sectionCardMultiBoxer}-dwd2" data-type="${sectionType.sectionCardMultiBoxer}" data-title="Card Multi Boxer Section" data-attribute="section-title">
                ${cardMultiBoxerSection}
            </section>`,
          image: cardMultiBoxerImg,
        },
        {
          id: sectionType.sectionCardReviewsBoxer,
          title: 'Reviews Boxer Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionCardReviewsBoxer,
          html: `<section data-section="${sectionType.sectionCardReviewsBoxer}-dwd2" data-type="${sectionType.sectionCardReviewsBoxer}" data-title="Reviews Boxer Section" data-attribute="section-title">
                ${reviewsBoxerSection}
            </section>`,
          image: reviewsBoxerImg,
        },
        {
          id: sectionType.sectionSliderBoxerProduct,
          title: 'Slider Boxer Product Section',
          tplType: TplType.Products,
          type: sectionType.sectionSliderBoxerProduct,
          html: `<section data-section="${sectionType.sectionSliderBoxerProduct}-dwd2" data-type="${sectionType.sectionSliderBoxerProduct}" data-title="Slider Boxer Product Section" data-attribute="section-title">
                ${sliderBoxerProductSection}
            </section>`,
          image: sliderBoxerProductImg,
        },
        {
          id: sectionType.sectionImageWithTextConvenFeet01,
          title: 'Image With Text Conven Feet 01 Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionImageWithTextConvenFeet01,
          html: `<section data-section="${sectionType.sectionImageWithTextConvenFeet01}-dwd2" data-type="${sectionType.sectionImageWithTextConvenFeet01}" data-title="Image With Text Conven Feet 01 Section" data-attribute="section-title">
                ${imageWithTextConvenFeet01Section}
            </section>`,
          image: imageWithTextConvenFeet01Img,
        },
        {
          id: sectionType.sectionImageWithTextConvenFeet02,
          title: 'Image With Text Conven Feet 02 Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionImageWithTextConvenFeet02,
          html: `<section data-section="${sectionType.sectionImageWithTextConvenFeet02}-dwd2" data-type="${sectionType.sectionImageWithTextConvenFeet02}" data-title="Image With Text Conven Feet 02 Section" data-attribute="section-title">
                ${imageWithTextConvenFeet02Section}
            </section>`,
          image: imageWithTextConvenFeet02Img,
        },
        {
          id: sectionType.sectionImageWithTextConvenFeet03,
          title: 'Image With Text Conven Feet 03 Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionImageWithTextConvenFeet03,
          html: `<section data-section="${sectionType.sectionImageWithTextConvenFeet03}-dwd2" data-type="${sectionType.sectionImageWithTextConvenFeet03}" data-title="Image With Text Conven Feet 03 Section" data-attribute="section-title">
                ${imageWithTextConvenFeet03Section}
            </section>`,
          image: imageWithTextConvenFeet03Img,
        },
        {
          id: sectionType.sectionIconGridWithHeroTextConvenFeet,
          title: 'Icon Grid With Hero Text Conven Feet Section',
          tplType: TplType.TextWithIcon,
          type: sectionType.sectionIconGridWithHeroTextConvenFeet,
          html: `<section data-section="${sectionType.sectionIconGridWithHeroTextConvenFeet}-dwd2" data-type="${sectionType.sectionIconGridWithHeroTextConvenFeet}" data-title="Icon Grid With Hero Text Conven Feet Section" data-attribute="section-title">
                ${iconGridWithHeroTextConvenFeetSection}
            </section>`,
          image: iconGridWithHeroTextConvenFeetImg,
        },
        {
          id: sectionType.sectionCalyrafitBanner,
          title: 'Calyrafit Banner Section',
          tplType: TplType.Banner,
          type: sectionType.sectionCalyrafitBanner,
          html: `<section data-section="${sectionType.sectionCalyrafitBanner}-dwd2" data-type="${sectionType.sectionCalyrafitBanner}" data-title="Calyrafit Banner Section" data-attribute="section-title">
                ${calyrafitBannerSection}
            </section>`,
          image: calyrafitBannerImg,
        },
        {
          id: sectionType.sectionCalyrafitMarquee01,
          title: 'Calyrafit Marquee 01 Section',
          tplType: TplType.Markqueues,
          type: sectionType.sectionCalyrafitMarquee01,
          html: `<section data-section="${sectionType.sectionCalyrafitMarquee01}-dwd2" data-type="${sectionType.sectionCalyrafitMarquee01}" data-title="Calyrafit Marquee 01 Section" data-attribute="section-title">
                ${calyrafitMarquee01Section}
            </section>`,
          image: calyrafitMarquee01Img,
        },
        {
          id: sectionType.sectionCalyrafitMarquee,
          title: 'Calyrafit Marquee Section',
          tplType: TplType.Markqueues,
          type: sectionType.sectionCalyrafitMarquee,
          html: `<section data-section="${sectionType.sectionCalyrafitMarquee}-dwd2" data-type="${sectionType.sectionCalyrafitMarquee}" data-title="Calyrafit Marquee Section" data-attribute="section-title">
                ${calyrafitMarqueeSection}
            </section>`,
          image: calyrafitMarqueeImg,
        },
        {
          id: sectionType.sectionCalyrafitGirdImage,
          title: 'Calyrafit Grid Image Section',
          tplType: TplType.GridItems,
          type: sectionType.sectionCalyrafitGirdImage,
          html: `<section data-section="${sectionType.sectionCalyrafitGirdImage}-dwd2" data-type="${sectionType.sectionCalyrafitGirdImage}" data-title="Calyrafit Grid Image Section" data-attribute="section-title">
                ${calyrafitGirdImageSection}
            </section>`,
          image: calyrafitGirdImageImg,
        },
        {
          id: sectionType.sectionCalyrafitBestSaller,
          title: 'Calyrafit Best Seller Section',
          tplType: TplType.Products,
          type: sectionType.sectionCalyrafitBestSaller,
          html: `<section data-section="${sectionType.sectionCalyrafitBestSaller}-dwd2" data-type="${sectionType.sectionCalyrafitBestSaller}" data-title="Calyrafit Best Seller Section" data-attribute="section-title">
                ${calyrafitBestSallerSection}
            </section>`,
          image: calyrafitBestSallerImg,
        },
        {
          id: sectionType.sectionCalyrafitSideBySide,
          title: 'Calyrafit Side By Side Section',
          tplType: TplType.TextWithIcon,
          type: sectionType.sectionCalyrafitSideBySide,
          html: `<section data-section="${sectionType.sectionCalyrafitSideBySide}-dwd2" data-type="${sectionType.sectionCalyrafitSideBySide}" data-title="Calyrafit Side By Side Section" data-attribute="section-title">
                ${calyrafitSideBySideSection}
            </section>`,
          image: calyrafitSideBySideImg,
        },
        {
          id: sectionType.sectionCalyrafitSlide,
          title: 'Calyrafit Slide Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionCalyrafitSlide,
          html: `<section data-section="${sectionType.sectionCalyrafitSlide}-dwd2" data-type="${sectionType.sectionCalyrafitSlide}" data-title="Calyrafit Slide Section" data-attribute="section-title">
                ${calyrafitSlideSection}
            </section>`,
          image: calyrafitSlideImg,
        },
        {
          id: sectionType.sectionCalyrafitCollections,
          title: 'Calyrafit Collections Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionCalyrafitCollections,
          html: `<section data-section="${sectionType.sectionCalyrafitCollections}-dwd2" data-type="${sectionType.sectionCalyrafitCollections}" data-title="Calyrafit Collections Section" data-attribute="section-title">
                ${calyrafitCollectionsSection}
            </section>`,
          image: calyrafitCollectionsImg,
        },
        {
          id: sectionType.sectionCalyrafitTextWithIcon,
          title: 'Calyrafit Text With Icon Section',
          tplType: TplType.TextWithIcon,
          type: sectionType.sectionCalyrafitTextWithIcon,
          html: `<section data-section="${sectionType.sectionCalyrafitTextWithIcon}-dwd2" data-type="${sectionType.sectionCalyrafitTextWithIcon}" data-title="Calyrafit Text With Icon Section" data-attribute="section-title">
                ${calyrafitTextWithIconSection}
            </section>`,
          image: calyrafitTextWithIconImg,
        },
        {
          id: sectionType.sectionCalyrafitReview,
          title: 'Calyrafit Review Section',
          tplType: TplType.Carousel,
          type: sectionType.sectionCalyrafitReview,
          html: `<section data-section="${sectionType.sectionCalyrafitReview}-dwd2" data-type="${sectionType.sectionCalyrafitReview}" data-title="Calyrafit Review Section" data-attribute="section-title">
                ${calyrafitReviewSection}
            </section>`,
          image: calyrafitReviewImg,
        },
        {
          id: sectionType.sectionCalyrafitFooter,
          title: 'Calyrafit Footer Section',
          tplType: TplType.Footer,
          type: sectionType.sectionCalyrafitFooter,
          html: `<section data-section="${sectionType.sectionCalyrafitFooter}-dwd2" data-type="${sectionType.sectionCalyrafitFooter}" data-title="Calyrafit Footer Section" data-attribute="section-title">
                ${calyrafitFooterSection}
            </section>`,
          image: calyrafitFooterImg,
        },
        {
          id: sectionType.sectionCeflorecoBanner1,
          title: 'Cefloreco Banner 1 Section',
          tplType: TplType.Banner,
          type: sectionType.sectionCeflorecoBanner1,
          html: `<section data-section="${sectionType.sectionCeflorecoBanner1}-dwd2" data-type="${sectionType.sectionCeflorecoBanner1}" data-title="Cefloreco Banner 1 Section" data-attribute="section-title">
                ${ceflorecoBanner1Section}
            </section>`,
          image: ceflorecoBanner1Img,
        },
        {
          id: sectionType.sectionCeflorecoProductWorld,
          title: 'Cefloreco Product World Section',
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoProductWorld,
          html: `<section data-section="${sectionType.sectionCeflorecoProductWorld}-dwd2" data-type="${sectionType.sectionCeflorecoProductWorld}" data-title="Cefloreco Product World Section" data-attribute="section-title">
                ${ceflorecoProductWorldSection}
            </section>`,
          image: ceflorecoProductWorldImg,
        },
        {
          id: sectionType.sectionCeflorecoBanner2,
          title: 'Cefloreco Banner 2 Section',
          tplType: TplType.Banner,
          type: sectionType.sectionCeflorecoBanner2,
          html: `<section data-section="${sectionType.sectionCeflorecoBanner2}-dwd2" data-type="${sectionType.sectionCeflorecoBanner2}" data-title="Cefloreco Banner 2 Section" data-attribute="section-title">
                ${ceflorecoBanner2Section}
            </section>`,
          image: ceflorecoBanner2Img,
        },
        {
          id: sectionType.sectionCeflorecoTextGradient,
          title: 'Cefloreco Text Gradient Section',
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoTextGradient,
          html: `<section data-section="${sectionType.sectionCeflorecoTextGradient}-dwd2" data-type="${sectionType.sectionCeflorecoTextGradient}" data-title="Cefloreco Text Gradient Section" data-attribute="section-title">
                ${ceflorecoTextGradientSection}
            </section>`,
          image: ceflorecoTextGradientImg,
        },
        {
          id: sectionType.sectionCeflorecoSideBySide,
          title: 'Cefloreco Side By Side Section',
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoSideBySide,
          html: `<section data-section="${sectionType.sectionCeflorecoSideBySide}-dwd2" data-type="${sectionType.sectionCeflorecoSideBySide}" data-title="Cefloreco Side By Side Section" data-attribute="section-title">
                ${ceflorecoSideBySideSection}
            </section>`,
          image: ceflorecoSideBySideImg,
        },
        {
          id: sectionType.sectionCeflorecoMobileApp,
          title: 'Cefloreco Mobile App Section',
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoMobileApp,
          html: `<section data-section="${sectionType.sectionCeflorecoMobileApp}-dwd2" data-type="${sectionType.sectionCeflorecoMobileApp}" data-title="Cefloreco Mobile App Section" data-attribute="section-title">
                ${ceflorecoMobileAppSection}
            </section>`,
          image: ceflorecoMobileAppImg,
        },
        {
          id: sectionType.sectionCeflorecoBenefis,
          title: 'Cefloreco Benefis Section',
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoBenefis,
          html: `<section data-section="${sectionType.sectionCeflorecoBenefis}-dwd2" data-type="${sectionType.sectionCeflorecoBenefis}" data-title="Cefloreco Benefis Section" data-attribute="section-title">
                ${ceflorecoBenefisSection}
            </section>`,
          image: ceflorecoBenefisImg,
        },
        {
          id: sectionType.sectionCeflorecoLetsTalk,
          title: "Cefloreco Let's Talk Section",
          tplType: TplType.Other,
          type: sectionType.sectionCeflorecoLetsTalk,
          html: `<section data-section="${sectionType.sectionCeflorecoLetsTalk}-dwd2" data-type="${sectionType.sectionCeflorecoLetsTalk}" data-title="Cefloreco Let's Talk Section" data-attribute="section-title">
                ${ceflorecoLetsTalkSection}
            </section>`,
          image: ceflorecoLetsTalkImg,
        },
        {
          id: sectionType.sectionCeflorecoFooter,
          title: 'Cefloreco Footer Section',
          tplType: TplType.Footer,
          type: sectionType.sectionCeflorecoFooter,
          html: `<section data-section="${sectionType.sectionCeflorecoFooter}-dwd2" data-type="${sectionType.sectionCeflorecoFooter}" data-title="Cefloreco Footer Section" data-attribute="section-title">
                ${ceflorecoFooterSection}
            </section>`,
          image: ceflorecoFooterImg,
        },
      ],
    };
  },
};
